<!--支付开户(未开户)-->
<template>
  <div v-loading="loading" class="container">
    <!--未提交开户申请-->
    <div v-if="notSubmitted" class="module no-account-opened">
      <h5>统一支付功能介绍</h5>
      <div class="main">
        <p>
          易派客支付是依托中国石化统一电商支付平台，与合作银行共同打造的B2B在线支付服务。
        </p>
        <p>
          完成易派客支付的注册开户并激活帐户后，您可以通过易派客平台方便、安全的支付或收取平台订单货款，平台将为您提供交易过程中的资金监管和保障，降低货物流动与资金流动的交易风险。
        </p>
        <p>易派客支付还将陆续提供其他交易服务，为您提供更多便利。</p>
      </div>
      <eui-btn width="220" type="primary" @click="handleAccountOpening(true)"
        >我已了解，现在去申请开户>></eui-btn
      >
    </div>
    <!--显示开户申请审核进度 或 申请开户-->
    <template v-if="!notSubmitted">
      <div class="account-opening">
        <div class="module" style="height: auto">
          <div>支付平台账户开户</div>
          <steps :steps-list="stepsList"></steps>
          <div
            v-if="accountStatus > 100 && !editAfterReview"
            class="review-progress"
          >
            <img
              v-if="iconName === 'submitted'"
              :src="require(`@/assets/img/paymenAccount/${iconName}.png`)"
              style="width: 180px"
            />
            <img
              v-else
              :src="require(`@/assets/img/paymenAccount/${iconName}.png`)"
            />
            <!--审核状态为待初审/待复审-->
            <p
              v-if="waittingReviewStatus.includes(accountStatus)"
              class="review-text"
            >
              您提交的开户申请资料我们已经收到，我们将尽快完成资料审核，请耐心等待，谢谢！
            </p>
            <div>
              <eui-btn
                v-if="accountStatus === 109"
                type="text"
                style="margin-right: 50px"
                @click="handleOpenDialog('activeWayVisible')"
              >
                激活方式查看
              </eui-btn>
              <eui-btn
                v-if="[105, 109].includes(accountStatus)"
                type="text"
                size="small"
                class="review-ukey-button"
                @click="handleOpenDialog('ukeyVisible')"
                >Ukey收件人信息查看
              </eui-btn>
            </div>

            <!--审核状态为复审通过-->
            <template v-if="accountStatus === 105">
              <p class="review-text margin-b20">
                支付平台银行账号为{{
                  accountStatusObj?.bankAccount
                }}。由于近期应监管部门要求，还需审核开户公司的真实性，<br />
                请提供
                <eui-btn
                  type="text"
                  size="small"
                  @click="handleOpenDialog('proveDocumentVisible')"
                  >相关证明材料
                </eui-btn>
                发送至邮箱：wzliuweiwei@sinopec.com。我们将尽快为您开户并寄送UKEY。
              </p>
            </template>
            <!--审核状态为待激活-->
            <p v-if="accountStatus === 109" class="review-text margin-b20">
              <!-- UKey已寄出，快递单号{{
                accountStatusObj?.epaySettleAccountUkeyTempVO?.trackingNumber
              }}，请注意查收，收到Ukey后请及时激活账户，账号为：{{
                accountStatusObj?.bankAccount
              }}。长时间未激活的账户，系统将会自动注销。 -->
              UKey已寄出，快递单号{{
                accountStatusObj?.epaySettleAccountUkeyTempVO?.trackingNumber
              }}，请注意查收并进行激活，长时间未激活的账户，系统将会自动注销
            </p>
            <div v-if="[105, 109].includes(accountStatus)">
              <eui-btn type="primary" @click="handleCancel">注销</eui-btn>
            </div>
            <!--审核状态为审核拒绝-->
            <template v-if="reviewRefuseStatus.includes(accountStatus)">
              <p class="review-text">
                您提交的开户申请资料{{
                  accountStatus === 104 ? '复审失败' : '初审失败'
                }}，请按提示内容修改申请后，再次提交申请。
              </p>
              <div class="review-reason margin-b20">
                <img src="@/assets/img/paymenAccount/warning.png" alt="" />
                <p v-if="accountStatusObj?.auditReason">
                  {{ accountStatusObj?.auditReason }}
                </p>
              </div>
              <eui-btn type="primary" @click="handleAccountOpening"
                >修 改</eui-btn
              >
            </template>
          </div>
        </div>
        <!--显示申请开户页面 或 显示账户状态为保存时的详情页面-->
        <component
          :is="currentComponent"
          v-if="showOperateBtnStatus.includes(accountStatus) || editAfterReview"
          :ref="currentComponent"
        ></component>
      </div>
      <!--申请开户时显示 或 账户状态为保存未提交时显示-->
      <div
        v-if="showOperateBtnStatus.includes(accountStatus) || editAfterReview"
        :style="{ marginTop: accountOpeningEdit ? 0 : '20px' }"
        class="footer-button"
      >
        <eui-btn
          v-show="currentComponent !== 'paymentAccountDetail'"
          type="secondary"
          @click="handleReturn"
          >返 回</eui-btn
        >
        <!-- 账户状态为保存未提交，显示修改按钮-->
        <div
          v-if="accountStatus === 100 && !accountOpeningEdit"
          class="operate-button"
        >
          <eui-btn type="primary" @click="handleAccountOpening">修 改</eui-btn>
        </div>
        <!-- 申请开户 或 修改开户信息-->
        <div v-if="accountOpeningEdit" class="operate-button">
          <eui-btn v-debounce="() => handleSave(100)" type="primary"
            >保 存</eui-btn
          >
          <eui-btn v-debounce="handleSubmit" type="primary">提 交</eui-btn>
        </div>
      </div>
    </template>

    <!--激活方式查看-->
    <e-dialog
      dialog-title="激活方式"
      :center-dialog-visible="activeWayVisible"
      :popup-width="'600px'"
      :show-btn="false"
      :show-close-btn="true"
      @resetPopupData="activeWayVisible = false"
    >
      <p style="font-weight: 500">
        使用开户时填写的对公账户通过网银向开户账户转账1元钱激活。
      </p><br>
      <p>
        对公账户（账号：{{
          accountStatusObj?.epayAccountBaseInfoVO?.bankAccount
        }}，开户行联行号：{{
          accountStatusObj?.epayAccountBaseInfoVO?.bankSerials
        }}，开户行名称：{{ accountStatusObj?.epayAccountBaseInfoVO?.bankAccountName }}）
      </p><br>
      <p>
        开户账户（公司名称：{{
          accountStatusObj?.epayAccountBaseInfoVO?.companyName
        }}，账号：{{ accountStatusObj.bankAccount }}，开户行名称：中信银行北京分行营业部，开户行联行号：302100011106）
      </p>
    </e-dialog>
    <!--ukey收件人信息-->
    <e-dialog
      dialog-title="ukey收件人信息"
      :center-dialog-visible="ukeyVisible"
      :popup-width="'400px'"
      :show-btn="false"
      :show-close-btn="true"
      @resetPopupData="ukeyVisible = false"
    >
      <div class="dialog-box">
        <div class="">
          <span class="label">收件人姓名：</span>
          <span class="value">{{
            accountStatusObj?.epaySettleAccountUkeyTempVO?.realName
          }}</span>
        </div>
        <div>
          <span class="label">收件人电话：</span>
          <span class="value">{{
            accountStatusObj?.epaySettleAccountUkeyTempVO?.mobile
          }}</span>
        </div>
        <div>
          <span class="label">收件人公司：</span>
          <span class="value">{{
            accountStatusObj?.epaySettleAccountUkeyTempVO?.receiverCompanyName
          }}</span>
        </div>
        <div>
          <span class="label">收件人地址：</span>
          <span class="value"
            >{{ accountStatusObj?.epaySettleAccountUkeyTempVO?.province
            }}{{ accountStatusObj?.epaySettleAccountUkeyTempVO?.city
            }}{{ accountStatusObj?.epaySettleAccountUkeyTempVO?.district
            }}{{ accountStatusObj?.epaySettleAccountUkeyTempVO?.address }}</span
          >
        </div>
      </div>
    </e-dialog>
    <!--相关证明材料-->
    <e-dialog
      dialog-title="相关证明材料"
      :center-dialog-visible="proveDocumentVisible"
      :popup-width="'500px'"
      @resetPopupData="proveDocumentVisible = false"
      @submitPopupData="proveDocumentVisible = false"
    >
      <div class="dialog-box">
        满足以下任一标准：<br />
        （1）公司为国央企及其控股分子公司、上市公司及控股子公司；<br />
        （2）公司公开信息查询为A级纳税人；<br />
        （3）各类特许经营行业，提供公司持有特许经营许可证复印件；<br />
        （4）公司已在中信银行开立单位银行结算账户（账户名称、账号、联行号、地址），提供账户信息；<br />
        （5）提供公司近一年内主营业务发票（一张即可）复印件；
      </div>
    </e-dialog>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import _ from 'lodash';
import EDialog from '../../components/common/e-dialog.vue';
import PaymentAccountDetail from './paymentAccountOpening/paymentAccountDetail';
import PaymentAccountOpening from './paymentAccountOpening/paymentAccountOpening';
import Steps from './components/steps';

export default {
  name: 'PaymentAccount',
  components: { PaymentAccountDetail, PaymentAccountOpening, EDialog, Steps },
  props: {},
  data() {
    return {
      loading: false,
      currentComponent: 'paymentAccountOpening',
      stepsList: [
        {
          step: 1,
          desc: '待提交',
          statusCode: '0,100,102,104',
          active: false,
          time: '',
        },
        {
          step: 2,
          desc: '待初审',
          statusCode: '101',
          active: false,
          time: '',
        },
        {
          step: 3,
          desc: '待复审',
          statusCode: '103',
          active: false,
          time: '',
        },
        {
          step: 4,
          desc: '待激活账户',
          statusCode: '105, 109',
          active: false,
          time: '',
        },
        {
          step: 5,
          desc: '开户成功',
          statusCode: '106',
          active: false,
          time: '',
        },
      ],
      ukeyVisible: false,
      activeWayVisible: false, // 激活方式查看
      proveDocumentVisible: false,
      notSubmitted: true, // 未提交开户申请
      accountOpeningEdit: false, // 开户申请编辑
      editAfterReview: false, // 审核拒绝后编辑
      accountStatus: null,
      accountStatusObj: {},
      showOperateBtnStatus: [0, 100], // 账户状态为未开通、保存未提交
      reviewRefuseStatus: [102, 104], // 账户状态为初审拒绝、复审拒绝
      waittingReviewStatus: [101, 103], // 账户状态为待初审、待复审
      waittingActiveStatus: [105, 109], // 账户状态为复审通过、待激活
    };
  },
  computed: {
    iconName() {
      // 账户状态为复审通过、待激活
      if (this.waittingActiveStatus.includes(this.accountStatus)) {
        return 'review-waitting';
      }
      // 账户状态为初审拒绝、复审拒绝
      if (this.reviewRefuseStatus.includes(this.accountStatus)) {
        return 'review-fail';
      }
      return 'submitted';
    },
  },
  watch: {},
  created() {},
  mounted() {
    // 查询结算账户状态
    this.initData();
  },
  methods: {
    // 查询结算账户状态
    async initData() {
      this.loading = true;
      const res = await Api.getEpaySettleAccountStatus().finally(() => {
        this.loading = false;
      });
      if (res.code === '200') {
        this.accountStatus = res.data?.accountStatus;
        // this.accountStatus = 105;
        this.accountStatusObj = res.data;
        this.notSubmitted = this.accountStatus === 0;
        const step = this.stepsList.find(
          (item) => item?.statusCode.indexOf(this.accountStatus) > -1
        )?.step;
        this.stepsList.forEach((item) => {
          if (item.step < step || item.step === step) {
            item.active = true;
          }
          if (item.step < step) {
            if (item.step === 1) {
              item.time = res.data?.applyTime;
            }
            if (item.step === 2) {
              item.desc = '初审通过';
              item.time = res.data?.trialTime;
            }
            if (item.step === 3) {
              item.desc = '复审通过';
              item.time = res.data?.reviewTime;
            }
          }
          // if (
          //   item.step === step &&
          //   this.reviewRefuseStatus.includes(this.accountStatus)
          // ) {
          //   item.desc = '审核拒绝';
          // }
        });
        // 账户状态为保存未提交
        if (this.accountStatus === 100) {
          this.currentComponent = 'paymentAccountDetail';
          this.$nextTick(() => {
            this.$refs[this.currentComponent].initData(res.data.tempId);
          });
        }
      }
    },
    // 开户申请 和 编辑开户申请信息
    async handleAccountOpening(flag) {
      if (this.accountStatus === null) {
        return;
      }
      const res = await Api.checkBusinessLicenseInfoIsIntact();
      if (res.code === '200') {
        if (res.data.status) {
          // 申请开户
          if (flag) {
            this.notSubmitted = false;
          }
          this.editAfterReview = true;
          this.accountOpeningEdit = true;
          this.currentComponent = 'paymentAccountOpening';
          this.$nextTick(() => {
            this.$refs[this.currentComponent]?.initData(
              this.accountStatusObj?.tempId
            );
          });
        } else {
          this.$message.error(res.data.msg);
        }
      }
    },
    // 注销
    async handleCancel() {
      this.$confirm('请确认是否注销支付账户！', '提示', {
        confirmButtonText: '继续注销',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.autoCancelEpayAccountTemp();
      });
    },
    async autoCancelEpayAccountTemp() {
      const res = await Api.autoCancelEpayAccountTemp({
        tempId: this.accountStatusObj.tempId,
      });
      if (res.success) {
        await this.initData();
        this.stepsList = [
          {
            step: 1,
            desc: '待提交',
            statusCode: '0,100,102,104',
            active: true,
            time: '',
          },
          {
            step: 2,
            desc: '待初审',
            statusCode: '101',
            active: false,
            time: '',
          },
          {
            step: 3,
            desc: '待复审',
            statusCode: '103',
            active: false,
            time: '',
          },
          {
            step: 4,
            desc: '待激活账户',
            statusCode: '105, 109',
            active: false,
            time: '',
          },
          {
            step: 5,
            desc: '开户成功',
            statusCode: '106',
            active: false,
            time: '',
          },
        ];
      }
    },
    // Ukey收件人信息查看 和 相关证明材料查看
    handleOpenDialog(dialogVisible) {
      this[dialogVisible] = true;
    },
    // 提交
    async handleSubmit() {
      const vueComponent = this.$refs[this.currentComponent];
      const formName = [
        'companyBaseInfo',
        'applicantInfo',
        'legalPersonInfo',
        'userConfig',
        'ukeyRecipientInfo',
        'bankAccountInfo',
      ];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!vueComponent.$refs[item]?.$refs.ruleForm) {
            reject();
          }
          vueComponent.$refs[item].$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            }
          });
        });
      };
      Promise.all(formName.map((item) => validates(item))).then(() => {
        this.handleSave(101);
      });
    },
    // 保存
    async handleSave(type) {
      const vueComponent = this.$refs[this.currentComponent];
      const settleAccountAttachTempList = [
        ...vueComponent.$refs.companyBaseInfo.ruleForm
          .settleAccountAttachTempList,
        ...vueComponent.$refs.applicantInfo.ruleForm
          .settleAccountAttachTempList,
        ...vueComponent.$refs.legalPersonInfo.ruleForm
          .settleAccountAttachTempList,
      ];
      const params = {
        ..._.cloneDeep(vueComponent.$refs.companyBaseInfo.ruleForm),
        ..._.cloneDeep(vueComponent.$refs.applicantInfo.ruleForm),
        ..._.cloneDeep(vueComponent.$refs.legalPersonInfo.ruleForm),
        ..._.cloneDeep(vueComponent.$refs.bankAccountInfo.ruleForm),
        ..._.cloneDeep(vueComponent.$refs.ukeyRecipientInfo.ruleForm),
        ..._.cloneDeep(vueComponent.$refs.userConfig.ruleForm),
        settleAccountAttachTempList: _.cloneDeep(settleAccountAttachTempList),
      };
      params.accountStatus = type;
      params.opMode = vueComponent.$refs.userConfig.activeTab;
      const business = params.settleAccountAttachTempList.splice(0, 1)[0];
      params.certificateLongValid = Number(
        business.certificateLongValid || '0'
      );
      params.certificateEndTime = business.certificateEndTime;
      params.settleAccountAttachTempList.forEach((item) => {
        // 申请人证件/法定代表人证件
        if (item.attachType === 'LRC' || item.attachType === 'AC') {
          item.certificateBeginTime = item.certificateTimeRange?.[0];
          item.certificateEndTime = item.certificateTimeRange?.[1];
          delete item.certificateTimeRange;
        }
        item.certificateLongValid = item.certificateLongValid ? 1 : 0;
      });
      // 单人模式
      if (params.opMode === '1') {
        params.settleAccountUserTempList =
          params.settleAccountUserTempList.slice(0, 1);
        params.settleAccountUserTempList[0].role = 'F002,F003';
      }
      // else {
      //   delete params.settleAccountUserTempList[0].idnumber;
      //   delete params.settleAccountUserTempList[1].idnumber;
      // }
      delete params.checked;
      if (params.settleAccountUkeyTemp.provinceId) {
        params.settleAccountUkeyTemp.province =
          vueComponent.$refs.ukeyRecipientInfo.provinceList.find(
            (item) => item.areaId === params.settleAccountUkeyTemp.provinceId
          )?.areaName;
      }
      if (params.settleAccountUkeyTemp.cityId) {
        params.settleAccountUkeyTemp.city =
          vueComponent.$refs.ukeyRecipientInfo.cityList.find(
            (item) => item.areaId === params.settleAccountUkeyTemp.cityId
          )?.areaName;
      }
      if (params.settleAccountUkeyTemp.districtId) {
        params.settleAccountUkeyTemp.district =
          vueComponent.$refs.ukeyRecipientInfo.districtList.find(
            (item) => item.areaId === params.settleAccountUkeyTemp.districtId
          )?.areaName;
      }
      console.log(params, 'params');
      Api.addEpaySettleAccountApply(params).then((res) => {
        if (res.code === '200') {
          this.$message.success(type === 100 ? '保存成功' : '提交成功');
          this.handleReturn();
        }
      });
    },
    handleReturn() {
      this.accountOpeningEdit = false;
      this.editAfterReview = false;
      // this.accountStatus = 100;
      if (this.accountStatus === 100) {
        this.currentComponent = 'paymentAccountDetail';
      }
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './css/paymentAccount.scss';
</style>
